import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Col, Row, Nav, Card, Button } from "react-bootstrap";
import Footer from "../layouts/Footer";
import useManageLabRequests from "../hooks/patientDashboard/usemanageLabrequests";
import LabRequestHistoryTable from "../components/tables/LabRequestHistoryTable";
import LabRequestHistorySidebar from "../components/common/LabRequestHistorySidebar";
import Header from "../layouts/Header";
import LabMart from "../dashboard/LabMart";
import Radiology from "../components/tables/Radiology";
import MedicalReport from "../components/tables/MedicalReport";
import useManageRadiology from "../hooks/patientDashboard/useManageRadiology";
import RadiologyMart from "../components/tables/RadiologyMart";

export default function LabRequestHistory() {
  const { handleFechLabRequestsAlt, requests, loading } = useManageLabRequests();
  const {
    handleFechRadiology,
    loading: fetching,
    radiology,
    handleFechAllTest,
    handleQueryTest,
    tests,
    handleSubmitRequest,
  } = useManageRadiology();
  const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
  const [skin, setSkin] = React.useState(currentSkin);
  const [tabs, setTabs] = useState("mart");
  const location = useLocation();
  const navigate = useNavigate();

  const switchSkin = (mode) => {
    if (mode === "dark") {
      const btnWhite = document.getElementsByClassName("btn-white");
      for (const btn of btnWhite) {
        btn.classList.add("btn-outline-primary");
        btn.classList.remove("btn-white");
      }
      return;
    }

    const btnOutlinePrimary = document.getElementsByClassName("btn-outline-primary");
    for (const btn of btnOutlinePrimary) {
      btn.classList.remove("btn-outline-primary");
      btn.classList.add("btn-white");
    }
  };

  switchSkin(skin);
  useEffect(() => {
    switchSkin(skin);
  }, [skin]);

  useEffect(() => {
    handleFechLabRequestsAlt();
    handleFechRadiology();
    handleFechAllTest();
  }, []);

  useEffect(() => {
    if (location.hash) {
      setTabs(location.hash.replace("#", ""));
      return;
    }

    setTabs("mart");
  }, [location]);

  const handleTabChange = (tab) => {
    setTabs(tab);
    navigate(`#${tab}`);
  };

  const labCount = Array.isArray(requests) ? requests.length : 0;
  const radiologyCount = Array.isArray(radiology) ? radiology.length : 0;
  const scanCount = tests?.items?.length ?? 0;

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app t-5 p-4 p-lg-5">
        <div className="data-page-hero">
          <div className="data-page-copy">
            <span className="data-page-kicker">Examinations</span>
            <h2>Move through labs, radiology, and reports with more clarity</h2>
            <p>
              Browse diagnostics, review histories, and request new scans from a more elegant examinations workspace.
            </p>
          </div>
          <div className="data-page-stats">
            <div className="data-page-stat">
              <small>Lab Requests</small>
              <strong>{labCount}</strong>
            </div>
            <div className="data-page-stat">
              <small>Radiology</small>
              <strong>{radiologyCount}</strong>
            </div>
            <div className="data-page-stat">
              <small>Available Scans</small>
              <strong>{scanCount}</strong>
            </div>
          </div>
        </div>

        <Row className="g-5">
          <Col xl>
            <Nav className="nav-line d-none d-lg-flex flex-wrap mb-0 gap-0">
              <Button onClick={() => handleTabChange("mart")} variant="link" className={tabs === "mart" ? "active" : ""}>
                Lab Mart
              </Button>
              <Button
                onClick={() => handleTabChange("request-history")}
                variant="link"
                className={tabs === "request-history" ? "active" : ""}
              >
                Lab Request History
              </Button>
              <Button
                onClick={() => handleTabChange("radiology")}
                variant="link"
                className={tabs === "radiology" ? "active" : ""}
              >
                Radiology
              </Button>
              <Button onClick={() => handleTabChange("report")} variant="link" className={tabs === "report" ? "active" : ""}>
                Medical Report
              </Button>
            </Nav>

            <Row className="g-3">
              <Card className="data-panel">
                {tabs === "mart" && <LabMart />}
                {tabs === "request-history" && <LabRequestHistoryTable data={requests} loading={loading} />}
                {tabs === "radiology" && (
                  <>
                    <div className="data-panel-head">
                      {/* <div className="data-panel-copy">
                        <h5>Radiology</h5>
                        <p>Review scan requests or jump into scan booking when you need a new request.</p>
                      </div> */}
                      <div className="data-panel-actions">
                        <Button onClick={() => setTabs("radiology-mart")} variant="primary">
                          Request Scan
                        </Button>
                      </div>
                    </div>
                    <div className="data-table-shell pt-0">
                      <Radiology data={radiology} loading={fetching} />
                    </div>
                  </>
                )}
                {tabs === "report" && <MedicalReport data={requests} loading={loading} />}
                {tabs === "radiology-mart" && (
                  <div className="data-table-shell">
                    <RadiologyMart
                      handleSubmitRequest={handleSubmitRequest}
                      handleFechAllTest={handleFechAllTest}
                      handleQueryTest={handleQueryTest}
                      data={tests}
                      loading={fetching}
                    />
                  </div>
                )}
              </Card>
            </Row>
          </Col>

          {tabs !== "mart" && (
            <Col xl="3" className="d-none d-xl-block">
              <LabRequestHistorySidebar />
            </Col>
          )}
        </Row>

        <Footer />
      </div>
    </React.Fragment>
  );
}
